import { Note, Point } from "../inspection-image";
import { ImageMetadata } from "./image-metadata";

/**
 * Brian 用 ImageMetadata クラス。
 */
export class BrianImageMetadata extends ImageMetadata {
  public mark?: number;
  public title: string;
  public tags: Array<string>;

  /** 本体情報 */
  public scope: BrianImageMetadataScope;

  /** ソフトウェア情報 */
  public software: BrianImageMetadataSoftware;

  /** 映像情報 */
  public video: BrianImageMetadataVideo;

  /** 光学アダプタ情報 */
  public opticalAdapter: BrianImageMetadataOpticalAdapter;

  /** 画像情報 */
  public image: BrianImageMetadataImage;

  /** 画像付加情報 */
  public imageAppendix: BrianImageMetadataImageAppendix;

  /** Brian(MTP)ベースユニット CCU情報 */
  public baseUnitCcu: BrianImageMetadataBaseUnitCcu;

  /** スケーラ計測情報 */
  public scalerMeasurement: BrianImageMetadataScalerMeasurement;

  /** ステレオ計測情報(共通) */
  public commonStereoMeasurement: BrianImageMetadataCommonStereoMeasurement;

  /** ステレオ計測情報1～6 */
  public stereoMeasurements: Array<BrianImageMetadataStereoMeasurement>;

  /** ステレオ計測情報7(計測データ) */
  public stereoMeasurement7: BrianImageMetadataStereoMeasurement7;

  /** ステレオ計測情報7(計測エンジンから出力される検知情報) */
  public stereoMeasurement7DetectionInfo: BrianImageMetadataStereoMeasurement7DetectionInfo;

  /** フリーコメント保存領域（1000文字） */
  public freecommentStorageArea: BrianImageMetadataFreecommentStorageArea;

  /** ノート保存領域 */
  public notes: Array<Note>;
}

/**
 * 本体情報
 */
export class BrianImageMetadataScope {
  /** ベースユニット種別（モデル） */
  public baseUnitType?: number;

  /** ベースユニットシリアル番号 */
  public baseUnitSerialNo: string;

  /** 製品型番 11文字 */
  public productModelNo?: number;

  /** ベースユニット種別2(ユニットバージョン) */
  public baseUnitType2?: number;

  /** スコープユニット種別(ユニットバージョン) */
  public scopeUnitType?: number;

  /** スコープユニットシリアル番号 */
  public scopeUnitSerialNo: string;

  /** スコープ径 */
  public scopeDiameter?: number;

  /** スコープ長 */
  public scopeLength?: number;

  /** スコープ組み込み年月日 */
  public scopeIncorporationDate: string;

  /** 機体のグレード情報（ライセンス） */
  public aircraftGradeInformation?: number;

  /** スコープ情報種別（光源） */
  public scopeInformationType?: number;

  /** GUID */
  public guid: string;
}

/**
 * ソフトウェア情報
 */
export class BrianImageMetadataSoftware {
  /** OSバージョン */
  public osVersion: string;

  /** Brianネイティブアプリケーションバージョン */
  public brianNativeApplicationVersion: string;

  /** メインプログラムバージョン（Brianクロスプラットフォームアプリケーションバージョン） */
  public mainProgramVersion: string;

  /** SCOPE-CPUバージョン */
  public scopeCpuVersion: string;

  /** SCOPE-ROMバージョン */
  public scopeRomVersion: string;

  /** LIGHT-CPUバージョン */
  public lightCpuVersion: string;

  /** ベースユニットバージョン */
  public baseUnitVersion: string;

  /** SCOPE-FPGAバージョン */
  public scopeFpgaVersion: string;

  /** SCOPE-FPGA-CONFIG-ROMバージョン */
  public scopeFpgaConfigRomVersion: string;
}

/**
 *映像情報
 */
export class BrianImageMetadataVideo {
  /** フレームモード */
  public frameMode?: number;

  /** ズーム */
  public zoom: string;

  /** 静止画ズーム */
  public zoomOfStillImage: string;

  /** ブライトネス */
  public brightness?: number;

  /** 画像の反転(インバート) */
  public imageInvert?: number;

  /** シャープネス */
  public sharpness?: number;

  /** 色調整 */
  public colorCalibration?: number;

  /** WiDER */
  public weider?: number;

  /** ノイズリダクション */
  public noiseReduction?: number;

  /** ステレオ光学アダプター画像表示モード */
  public imageDisplayModeOfStereoOpticalAdapter?: number;

  /** ゲインモード */
  public gainMode?: number;

  /** シーン判別 */
  public sceneDiscrimination?: number;

  /** コントラスト */
  public contrast?: number;

  /** Advance */
  public advance?: number;

  /** Advance GAIN */
  public advanceGain?: number;

  /** Advance 露光時間 */
  public advanceExposureTime?: number;

  /** AEモード */
  public aeMode?: number;

  /** グローバル発光制御 */
  public globalEmissionControl?: number;

  /** 光量 */
  public lightIntensity?: number;

  /** 画像自動回転 */
  public imageAutoRotate?: number;

  /** リアルタイム歪み補正 */
  public realtimeDistortionCorrection?: number;

  /** 重力値(X) */
  public gravityValueX?: number;

  /** 重力値(Y) */
  public gravityValueY?: number;

  /** 重力値(Z) */
  public gravityValueZ?: number;

  /** 重力情報 α（ローリング量） */
  public gravityInformationAlphaRollingQuantity?: number;

  /** 重力情報 β（ピッチ量） */
  public gravityInformationBetaPitchQuantity?: number;

  /** 湾曲センタリング状態 */
  public curvatureCenteringState?: number;

  /** 湾曲指示X */
  public curvatureIndicationX?: number;

  /** 湾曲指示Y */
  public curvatureIndicationY?: number;

  /** 湾曲センシング結果 ポテンショメータ角度X */
  public curvatureSensingResultPotentiometerAngleX?: number;

  /** 湾曲センシング結果 ポテンショメータ角度Y */
  public curvatureSensingResultPotentiometerAngleY?: number;

  /** 加速度センシング結果 ロール角 */
  public accelerationSensingResultRollAngle?: number;

  /** 加速度センシング結果 ピッチ角 */
  public accelerationSensingResultPitchAngle?: number;

  /** 挿入長情報（現在位置） Brianではリザーブ */
  public insertionLengthInformationCurrentPosition?: number;

  /** 挿入長情報（設定点①） Brianではリザーブ */
  public insertionLengthInformationSetPoint1?: number;

  /** 挿入長情報（設定点②） Brianではリザーブ */
  public insertionLengthInformationSetPoint2?: number;

  /** 挿入長単位 Brianではリザーブ */
  public insertionLengthUnit?: number;

  /** 挿入長形式 Brianではリザーブ */
  public insertionLengthFormat?: number;

  /** 挿入長演算パルス数 Brianではリザーブ */
  public insertionLengthArithmeticPulseNo?: number;

  /** 先端位置(X) Brianではリザーブ */
  public tipPositionX?: number;

  /** 先端位置(Y) Brianではリザーブ */
  public tipPositionY?: number;

  /** 先端位置(Z) Brianではリザーブ */
  public tipPositionZ?: number;

  /** 先端向き(X) Brianではリザーブ */
  public tipOrientationX?: number;

  /** 先端向き(Y) Brianではリザーブ */
  public tipOrientationY?: number;

  /** 先端向き(Z) Brianではリザーブ */
  public tipOrientationZ?: number;

  /** ブレードカウント */
  public bladeCount?: number;

  /** 最大ブレードカウント */
  public maxBladeCount?: number;
}

/**
 * 光学アダプタ情報
 */
export class BrianImageMetadataOpticalAdapter {
  /** 光学アダプタ種類 */
  public class?: number;

  /** 光学アダプタ種別 */
  public type?: number;

  /** 光学アダプタ名称 */
  public name: string;

  /** ステレオ光学アダプタセット番号 */
  public adapterSetNo: string;
}

/**
 * 画像情報
 */
export class BrianImageMetadataImage {
  /** 画像種別 */
  public type?: number;

  /** 再記録 */
  public rerecord?: number;

  /** プリントスクリーン */
  public printScreen?: number;

  /** コンペア */
  public compare?: number;

  /** 画像フィルタ */
  public filter?: number;
}

/**
 * 画像付加情報
 */
export class BrianImageMetadataImageAppendix {
  /** ファイルマーク1 */
  public filemark1?: number;

  /** タイトル1 */
  public title1: string;

  /** タイトル2 */
  public title2: string;

  /** タイトル3 */
  public title3: string;
}

/**
 * Brian(MTP)ベースユニット CCU情報
 */
export class BrianImageMetadataBaseUnitCcu {
  /** 基板状態取得コマンドで取得できるデータ */
  public boardStatusData?: number;

  /** 光源種類（白色LD/白色LED/UV/IR） */
  public lightSourceType?: number;

  /** パルス幅 (点灯時間)[us] */
  public pulseWidth?: number;

  /** AE情報 電荷蓄積時間[us] */
  public chargeAccumulationTime?: number;

  /** AE情報 アナログゲイン[dB] */
  public analogGain?: number;

  /** AE情報 デジタルゲイン[dB] */
  public digitalGain?: number;

  /** AE情報 イメージャー温度[degree] */
  public imagerTemperature?: number;

  /** 画像処理 WBパラメーターR */
  public wBParameterR?: number;

  /** 画像処理 WBパラメーターG */
  public wBParameterG?: number;

  /** 画像処理 WBパラメーターB */
  public wBParameterB?: number;

  /** 画像処理 ガンマ補正パラメーター */
  public gammaCorrectionParameter?: number;
}

/**
 * スケーラ計測情報
 */
export class BrianImageMetadataScalerMeasurement {
  /** スケール */
  public scale?: number;

  /** 距離 */
  public distance?: number;

  /** 基準長 */
  public referenceLength?: number;

  /** ディストーション補正係数 */
  public distortionCorrectionFactor?: number;

  /** 画角 */
  public angleOfView?: number;

  /** ディストーションタイプ */
  public distortionType?: number;

  /** 光学中心（Ｘ） */
  public opticalCenterX?: number;

  /** 光学中心（Ｙ） */
  public opticalCenterY?: number;

  /** 画像半径 */
  public imageRadius?: number;
}

/**
 * ステレオ計測情報(共通)
 * 計測結果１～計測結果６は、ステレオ計測情報の計測結果種別として取り込む。
 */
export class BrianImageMetadataCommonStereoMeasurement {
  /** 計測方式 */
  public measurementMethod: string;

  /** 計測結果の数 */
  public measurementResultCount?: number;

  /** サブピクセルポインティングON/OFF */
  public subPixelPointing?: number;
}

/**
 * ステレオ計測情報1～6
 */
export class BrianImageMetadataStereoMeasurement {
  /** 計測結果種別(計測結果) */
  public measurementType?: number;

  /** 計測点 */
  public measurementPoints: Array<Point>;
}

/**
 * ステレオ計測情報7(計測データ)
 */
export class BrianImageMetadataStereoMeasurement7 {
  /** 計測用情報領域③ */
  public measurementInformationArea3: string;
}

/**
 * ステレオ計測情報7(計測エンジンから出力される検知情報)
 */
export class BrianImageMetadataStereoMeasurement7DetectionInfo {
  /** 等速性1～6 */
  public isokinetics: Array<number>;

  /** 直線性1～6 */
  public linearities: Array<number>;

  /** 計測検具での精度確認未実施（動作フラグ） */
  public accuracyConfirmation?: number;

  /** AD回転ずれ検知（AD取り付け状態不良） */
  public adRotationMisalignmentDetection?: number;

  /** 被写体・カメラ動き抑制指示（ブレ検出） (カメラ・被写体の動きが大きい) */
  public motionSuppressionInstruction?: number;

  /** ハレーションによる3Dデータ欠損の恐れの警告（マッチング阻害要因検知） */
  public warningOf3DDataLossDueToHalation?: number;

  /** 異物の映り込みによる3Dデータ欠損の恐れの警告（マッチング阻害要因検知） */
  public warningOf3DDataLossDueToForeignObjectReflections?: number;

  /** MMA切替失敗検知 (時分割のみ) */
  public mmaSwitchingFailureDetection?: number;

  /** 計測検具での精度確認で算出した計測値 */
  public accuracyConfirmationValue?: number;
}

/**
 * フリーコメント保存領域（1000文字）
 */
export class BrianImageMetadataFreecommentStorageArea {
  /** 画像に付加するコメント */
  public imageAdditionalComment: string;
}

/**
 * Brian 計測結果種別。
 */
export enum BrianMeasurementType {
  /** 計測結果がない場合は0。 */
  Invalid = 0,
  /** 2点間距離計測: 1 */
  DistanceBetweenTwoPoints = 1,
  /** 線基準計測: 2 (未使用) */
  LineBased = 2,
  /** 面基準計測: 3 */
  SurfaceBased = 3,
  /** 面積計測: 4 */
  Area = 4,
  /** 全長計測: 5 */
  FullLength = 5,
  /** オフセット計測: 6 */
  Offset = 6,
  /** 自動欠損: 7 */
  AutomaticLoss = 7,
  /** 表面形状: 8 */
  SurfaceShape = 8,
  /** 2Dスケーラ計測: 9 */
  TwoDimensionalScaler = 9,
  /** 物体距離計測: 10（予備） */
  ObjectDistance = 10,
  /** ライブ測距計測: 11 */
  LiveDistance = 11,
  /** 曲面基準計測: 12 */
  CurvedSurfaceBased = 12,
  /** ブレンディング計測（円弧計測）: 13 */
  Blending = 13,
  /** コーナー欠損計測: 14 */
  CornerLoss = 14,
  /** チップクリアランス計測: 15 */
  ChipClearance = 15,
  /** ゲージ計測(球): 16 */
  SphereGauge = 16,
  /** ゲージ計測（円筒）: 17 */
  CylindricalGauge = 17
}
